import axios from "axios";
import { React, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";

function DroppedStatus({ onClose, company_id }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const onSubmit = async (data) => {
    await axios.post(
      `${API_BASE_URL}/companyinfo/update_fields`,
      {
        id: company_id,
        pipeline_status: "Dropped",
        dropped_status_notes: data.dropped_status,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    toastr.success(`Dropped status updated successfully`);
    onClose();
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered text-center">
          <div className="modal-content modal-content-demo">
            <div className="modal-header">
              <h4 className="modal-title">Dropped Status</h4>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-body text-start">
                <div className="row text-center">
                  <div className="col-md-12 ms-auto">
                    <textarea
                      {...register("dropped_status", {
                        required: true,
                      })}
                      className={
                        errors.dropped_status
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder="Enter Dropped Status Notes"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-center">
                <button
                  disabled={loading}
                  className="btn btn-md btn-primary rounded-pill"
                  type="submit"
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-md btn-danger rounded-pill ms-1"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default DroppedStatus;
